import { render, staticRenderFns } from "./LoginLoad.vue?vue&type=template&id=97367b2a&scoped=true&"
import script from "./LoginLoad.vue?vue&type=script&lang=js&"
export * from "./LoginLoad.vue?vue&type=script&lang=js&"
import style0 from "./LoginLoad.vue?vue&type=style&index=0&id=97367b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97367b2a",
  null
  
)

export default component.exports